// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__1QwdI","info":"Note_info__3jd6f","note":"Note_note__2rCjL","actions":"Note_actions__1LKqQ"};